// extracted by mini-css-extract-plugin
export default {"imageBackground":"HrpPage_imageBackground__iO3S7","imageArea":"HrpPage_imageArea__BQ7BR","foldList":"HrpPage_foldList__bFPZG","table":"HrpPage_table__EiQgM"};